import { render, staticRenderFns } from "./deafultAdsList.vue?vue&type=template&id=07fa82fa&scoped=true"
import script from "./deafultAdsList.vue?vue&type=script&lang=js"
export * from "./deafultAdsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07fa82fa",
  null
  
)

export default component.exports